export class PasswordResetRequiredError extends Error {}
